import { render } from "./ForgotPass.vue?vue&type=template&id=4d4d5c2b&scoped=true"
import script from "./ForgotPass.vue?vue&type=script&lang=js"
export * from "./ForgotPass.vue?vue&type=script&lang=js"

import "./ForgotPass.vue?vue&type=style&index=0&id=4d4d5c2b&lang=css"
import "./ForgotPass.vue?vue&type=style&index=1&id=4d4d5c2b&scoped=true&lang=css"
import "./ForgotPass.vue?vue&type=style&index=2&id=4d4d5c2b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d4d5c2b"]])

export default __exports__